import { useFormContext, useWatch } from 'react-hook-form'

import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { SubjectInformationItemContext } from './SubjectInformationItemContext'
import {
  AddressFields,
  AlternateName,
  BusinessType,
  CorroborativeStatementToFiler,
  Email,
  EntityFields,
  EntityNameOrLastName,
  FormOfIdentification,
  InstitutionInfo,
  IsAllInfoUnavailable,
  IsEntity,
  NAICSCode,
  NoKnownAccountsInvolved,
  Phone,
  RelationshipsInfo,
  RoleInActivity,
  TIN,
  TINType,
  WebSite
} from './fields'

import { s } from './styles'

type SubjectInformationItemProps = {
  index: number
}

export const SubjectInformationItem = (props: SubjectInformationItemProps) => {
  const { index } = props
  const { control } = useFormContext<SarEdit>()
  const isAllInfoUnavailable = useWatch({ control, name: `subjectsInfo.${index as 0}.isAllInfoUnavailable` })

  return (
    <SubjectInformationItemContext.Provider value={{ isAllInfoUnavailable }}>
      <s.Inner>
        <FormRow>
          <Col>
            <IsEntity index={index} />
            <IsAllInfoUnavailable index={index} />
          </Col>
        </FormRow>
        <FormRow>
          <Col>
            <EntityNameOrLastName index={index} />
          </Col>
        </FormRow>
        <FormRow>
          <Col>
            <AlternateName index={index} />
          </Col>
        </FormRow>
        <EntityFields index={index} />
        <FormRow>
          <Col>
            <BusinessType index={index} />
          </Col>
          <Col>
            <NAICSCode index={index} />
          </Col>
        </FormRow>
        <FormRow>
          <Col>
            <TIN index={index} />
          </Col>
          <Col>
            <TINType index={index} />
          </Col>
        </FormRow>
        <Phone index={index} />
        <FormRow>
          <Col>
            <Email index={index} />
          </Col>
          <Col>
            <WebSite index={index} />
          </Col>
        </FormRow>
        <FormRow>
          <Col>
            <CorroborativeStatementToFiler index={index} />
          </Col>
          <Col>
            <RoleInActivity index={index} />
          </Col>
        </FormRow>
        <AddressFields index={index} />
        <FormOfIdentification index={index} />
        <RelationshipsInfo index={index} />
        <FormRow>
          <Col>
            <h5>27. Financial Institution TIN and account number(s) affected that are related to subject</h5>
          </Col>
          <Col>
            <NoKnownAccountsInvolved index={index} />
          </Col>
        </FormRow>
        <InstitutionInfo index={index} />
      </s.Inner>
    </SubjectInformationItemContext.Provider>
  )
}
